import { gql } from 'graphql-tag'
import fragmentModuleMedia from '#layers/core/data-layer/modules/module-media/fragment-module-media'

export default gql`
  ${fragmentModuleMedia}
  fragment EventSpeakerFragment on EventSpeaker {
    sys {
      id
    }
    name
    contentType: __typename
    role
    speakerDescription: description
    speakerImage {
      ...ModuleMediaFragment
    }
  }
`
